// Vue 3 binds `:href` verbatim — a stored value like
// `javascript:alert(1)` (or `data:`, `vbscript:`) becomes an executable
// link an admin or compromised editor could plant. Artist social
// fields, gallery links and shop-link metadata all flow from the
// editor panel without a model-level URL validator, so the render
// path has to do the filtering itself.
//
// Allow http(s) and a tiny shortlist of safe schemes (mailto, tel).
// Anything else, including relative paths that start with a colon
// like `javascript:` after a leading slash, falls back to empty so
// the v-if drops the anchor entirely. Trim leading control + invisible
// whitespace first because payloads can hide the scheme behind a
// zero-width joiner or NBSP that classic `\s` won't strip.
//
// Invisible-char list (NBSP, soft hyphen, BiDi marks, zero-width
// joiners, ideographic space, BOM, …) is written as \uXXXX escapes so
// the source stays editor-safe — a literal invisible char in the
// regex would be invisible to reviewers and could get silently
// re-encoded by editors.
const SAFE_SCHEMES = /^(?:https?|mailto|tel):/i
const LEADING_INVISIBLE_RE = new RegExp(
    '^[\\s\\u00a0\\u00ad\\u034f\\u200b-\\u200f\\u2028-\\u202f\\u205f\\u2060\\u3000\\ufeff]+'
)

export function safeUrl(value: unknown): string {
    if (typeof value !== 'string') return ''
    const trimmed = value.replace(LEADING_INVISIBLE_RE, '')
    if (!trimmed) return ''
    // Relative URL (`/foo`, `./bar`, `#hash`, `?query`) — safe by construction.
    if (/^[\/?#]/.test(trimmed)) return trimmed
    return SAFE_SCHEMES.test(trimmed) ? trimmed : ''
}
